import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../types/types';
import { ITypeSwitcherDropUpHOCProps } from './types';
import { ITypeSwitcherDropUpEvents, ITypeSwitcherDropUpFields } from '../../components/TypeSwitcherDropUp/types';
import { TypeSwitcherDropUp } from '../../components/TypeSwitcherDropUp/TypeSwitcherDropUp';
import { getActiveBoardId } from 'app/store/model/selectors/getActiveBoardId';
import { getShowProFeaturesTrial } from '../../../../../store/model/authUser/selectors/getShowProFeaturesTrial';
import { EHintKey, EHintStatus } from '../../../hints';
import { getHint } from '../../../hints/store/hints/selectors/getHint';
import { getShowGanttContextHints } from '../../../hints/conditions/ganttContextConditions/getShowGanttContextHints';
import { getBoardPermissions } from '../../../../../store/model/selectors/getBoardPermissions';
import { onOpenCardPreviewSettings } from './events/onOpenCardPreviewSettings';
import { getIsUserEssentialPlanOnly } from '../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';
import { onLastKanbanViewOpen } from './events/onLastKanbanViewOpen';

const mapStateToProps = (
    state: IApplicationState,
    props: ITypeSwitcherDropUpHOCProps,
): ITypeSwitcherDropUpFields => {
    const { active, isExpanded } = props;
    const boardId = getActiveBoardId(state);
    const isShowHint = getShowGanttContextHints(state) &&
        getHint(state, EHintKey.GANTT_CONTEXT_GANTT_TYPE_SWITCHER).status === EHintStatus.SHOWN &&
        getHint(state, EHintKey.GANTT_CONTEXT_GANTT_VIEW).status === EHintStatus.NOT_SHOWN;
    return {
        active,
        isExpanded,
        isEssentialFeature: getIsUserEssentialPlanOnly(state),
        isProFeature: getShowProFeaturesTrial(state),
        isReadonly: getBoardPermissions(state, boardId) && !getBoardPermissions(state, boardId).authPermissions.allowEdit,
        isShowHint,
    }
};

const mapDispatchToProps = (
    dispatch: any,
    props: ITypeSwitcherDropUpHOCProps
): ITypeSwitcherDropUpEvents => {
    const { onTypeSelected, onClose } = props;
    return {
        onClose,
        onLastKanbanViewOpen: () => dispatch(onLastKanbanViewOpen(onClose)),
        onOpenPreviewSettings: () => dispatch(onOpenCardPreviewSettings()),
        onTypeSelected,
    }
};

export const TypeSwitcherDropUpHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(TypeSwitcherDropUp);
TypeSwitcherDropUpHOC.displayName = 'TypeSwitcherDropUpHOC';
